import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  initTabSystem({
    tabsContainerSelector: '.packing-section__tabs',
    panelsContainerSelector: '#packing-panels',
    tabSelector: '.packing-section__tab',
    panelSelector: '.packing-section__panel',
  });
});
